import { type ComponentProps, Suspense, lazy } from 'react';

import { Loader } from './Loader/Loader';

const SumsubWebSdk = lazy(() => import('@sumsub/websdk-react'));

export function LazySumsubWebSdk(props: ComponentProps<typeof SumsubWebSdk>) {
  return (
    <Suspense fallback={<Loader />}>
      <SumsubWebSdk {...props} />
    </Suspense>
  );
}
